var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"id_root"}},[_c('v-app',[_c('topBar'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }